import { RedirectionStateObject } from '../types';
import { tanstackUrlSearch, uriSafe } from '../utils';

export const dataHubRedirections: RedirectionStateObject = {
  'dashboard.cost': params => `/360/data-management/optimization${tanstackUrlSearch(params)}`,
  'dashboard.tools.logs-drop-filters': () => `/360/data-management/logs-drop-filters`,
  'dashboard.tools.metrics-drop-filters': params => {
    return `/360/data-management/metrics-drop-filters?${tanstackUrlSearch(params)}`;
  },
  'dashboard.tools.tracing-sampling-rules': params => {
    return `/360/data-management/traces/sampling-rules${tanstackUrlSearch(params)}`;
  },
  'dashboard.settings.tracing-yaml-configuration': params =>
    `/360/data-management/traces/yaml-configuration/localhost${tanstackUrlSearch(params)}`,
  'dashboard.settings.tracing-yaml-configuration.localhost': params =>
    `/360/data-management/traces/yaml-configuration/localhost${tanstackUrlSearch(params)}`,
  'dashboard.logs-to-metrics.definitions': () => '/360/data-management/logs-to-metrics',
  'dashboard.logs-to-metrics.new': params => `/360/data-management/logs-to-metrics/new?${tanstackUrlSearch(params)}`,
  'dashboard.logs-to-metrics.edit': params => {
    const { id, ...rest } = params || {};

    return `/360/data-management/logs-to-metrics/${uriSafe(id)}${tanstackUrlSearch(rest)}`;
  },
  'dashboard.tools.archive-and-restore': params =>
    `/360/data-management/archive-and-restore${tanstackUrlSearch(params)}`,
  'dashboard.tools.metrics-rollup': params => `/360/data-management/metric-rollups${tanstackUrlSearch(params)}`,
  'dashboard.parsing-rules-hub': params => `/360/data-configuration/parsing-rules-hub${tanstackUrlSearch(params)}`,
  'dashboard.new-parsing-rule': params => `/360/data-configuration/parsing-rules-hub/new${tanstackUrlSearch(params)}`,
  'dashboard.inspect-parsing-rule': ({ id, ...params }) => {
    return `/360/data-configuration/parsing-rules-hub/${uriSafe(id)}${tanstackUrlSearch(params)}`;
  },
  'dashboard.tools.field-mapping.mapping-configuration': () => `/360/data-configuration/field-mappings/configuration`,
  'dashboard.tools.field-mapping.mapping-errors': () => `/360/data-configuration/field-mappings/errors`,
};
